import { render, staticRenderFns } from "./ReportContact.vue?vue&type=template&id=325deaf7&"
import script from "./ReportContact.vue?vue&type=script&lang=js&"
export * from "./ReportContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports